import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getInvoices = (token: string, backend: string, projectId?, customerId?) => {
    return fetch(`${getApiUrl(backend)}get_all_invoices?${projectId ? '&project=' + projectId : ''}${customerId ? '&customer=' + customerId : ''}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getInvoices